import React, {useState} from "react";
import {useSelector} from "react-redux";
import {Icon, Text} from "@reside/ui";
import {FilterContainer} from "./style";

import {useStarredAdmissionsCount} from "../../../../atoms/dashboard-table/hooks/useStarredAdmissionsCount";
import {AppState, select} from "../../../../store";

type StarFilterProps = {
  active?: boolean; // controlled active state
  onFilterChange?: (isActive: boolean) => void;
};

export const StarFilter = ({active, onFilterChange}: StarFilterProps) => {
  const activeFacilitiesIds = useSelector((state: AppState) =>
    select.adminSession.activeFacilitiesIds(state),
  );
  const [internalActive, setInternalActive] = useState(false);
  const {data: totalStarredAdmissions} = useStarredAdmissionsCount();

  // Filter is disabled when totalStarredAdmissions is 0, undefined, or null or facility filter is "None"
  const isDisabled =
    !totalStarredAdmissions ||
    totalStarredAdmissions === 0 ||
    activeFacilitiesIds?.length === 0;

  // Derived active state (controlled if active prop provided)
  const isActive = active !== undefined ? active : internalActive;

  const handleClick = () => {
    if (isDisabled) return;

    const newActiveState = !isActive;
    if (active === undefined) {
      setInternalActive(newActiveState);
    }

    onFilterChange?.(newActiveState);
  };

  return (
    <FilterContainer
      isActive={isActive}
      onClick={handleClick}
      role="button"
      tabIndex={isDisabled ? -1 : 0}
      onKeyDown={e => {
        if (isDisabled) return;
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleClick();
        }
      }}
      disabled={isDisabled}
    >
      {/** Dual icon technique to display the correct icon based on the active state */}
      <Icon name="star-empty" size={16} className="star-icon" />
      <Icon name="star" size={16} className="star-icon-filled" />
      <Text as="p" marginLeft={1}>
        Starred
      </Text>
      {/*totalStarredAdmissions !== undefined && totalStarredAdmissions > 0 && (
        <Text as="p" marginLeft={1}>
          {totalStarredAdmissions}
        </Text>
      )*/}

      {isActive && <Icon name="clear" size={9} className="clear-icon" />}
    </FilterContainer>
  );
};
